import { useEffect, useState } from 'react';
import { listSucursales } from '../services/data';

export function useSucursales() {
  const [sucursales, setSucursales] = useState([]);
  useEffect(() => {
    listSucursales()
      .then((rows) => setSucursales(rows.map((v) => ({
        id: v.id,
        nombre: v.ubicacion || v.nombre || v.id,
        ubicacion: v.ubicacion || '',
        cajaChica: Number(v.cajaChica || 0),
      }))))
      .catch(console.error);
  }, []);
  return sucursales;
}
